// components
import ToolbarActionMenu from './ToolbarActionMenu';
import { StyledToolbarContainer, StyledToolbarSection } from './Toolbar.styles';
import DateNavigation from 'components/shared/DateNavigation/DateNavigation';
import { ActionStrip } from './ActionStrip';

// enums
import { ToolbarFlowEnum } from '../ToolbarWrapper.enums';

// styles
import { DateNavigationContainer } from 'components/shared/Header/Header.styles';

// types
import { ToolbarProps } from './Toolbar.types';
import { cloneElement, isValidElement } from 'react';

const Toolbar = ({
  actions,
  additionalActions,
  dateNavigation,
  isRightPositioned,
  isZenPositioned,
  setToolbarPosition,
  onMouseEnterZen,
  onMouseLeaveZen,
  zenOpen,
  planUnitSelector,
  toolbarFlow = ToolbarFlowEnum.GRID,
  component
}: ToolbarProps) => {
  const isVertical = isRightPositioned || isZenPositioned;
  const alignRightActions = actions?.filter(
    (action) => action.alignment === 'right'
  );
  const alignLeftActions = actions?.filter(
    (action) => action.alignment === 'left'
  );

  return (
    <StyledToolbarContainer
      isRightPositioned={isRightPositioned}
      isZenPositioned={isZenPositioned}
      zenOpen={zenOpen}
      onMouseEnter={onMouseEnterZen}
      onMouseLeave={onMouseLeaveZen}
      toolbarFlow={toolbarFlow}
    >
      {/* Exactly three children, one per grid area, so the date picker keeps the middle column even
          when components are injected either side of it. */}
      <StyledToolbarSection isVertical={isVertical}>
        <ActionStrip
          items={alignLeftActions}
          planUnitSelector={planUnitSelector}
          isVertical={isVertical}
        />

        {isValidElement(component?.beforeDatePicker)
          ? cloneElement(component.beforeDatePicker, {
              isRightPositioned: isRightPositioned || isZenPositioned
            })
          : component?.beforeDatePicker}
      </StyledToolbarSection>

      {dateNavigation?.showDateNavigation && (
        <DateNavigationContainer
          data-tourid={dateNavigation?.dateNavigationDataTourId}
        >
          <DateNavigation
            defaultPeriod={dateNavigation?.defaultPeriod ?? 'month'}
            defaultDate={dateNavigation?.selectedDate}
            defaultDateRange={dateNavigation?.selectedDateRange}
            onDateChange={dateNavigation?.onSelectedDate}
            onPeriodChange={dateNavigation?.onPeriodChange}
            options={dateNavigation?.dateNavigationOptions}
            allowMenuOptions={dateNavigation?.allowDateNavigationMenuOptions}
            hidePeriodDescription={dateNavigation?.hidePeriodDescription}
            persistPeriodPreference={dateNavigation?.persistPeriodPreference}
            isToolbar
            isRightPositioned={isRightPositioned || isZenPositioned}
          />
        </DateNavigationContainer>
      )}

      <StyledToolbarSection isVertical={isVertical}>
        {isValidElement(component?.afterDatePicker)
          ? cloneElement(component.afterDatePicker, {
              isRightPositioned: isRightPositioned || isZenPositioned
            })
          : component?.afterDatePicker}

        <ActionStrip
          items={alignRightActions}
          justifyEnd
          isVertical={isVertical}
        >
          <ToolbarActionMenu
            additionalActions={additionalActions}
            isAdditionalActions
            setToolbarPosition={setToolbarPosition}
            isRightPositioned={isVertical}
          />
        </ActionStrip>
      </StyledToolbarSection>
    </StyledToolbarContainer>
  );
};

export default Toolbar;
